var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "itp-section-padded",
      class: [_vm.schema.settings.backgroundColor],
      style: _vm.paddingStyles
    },
    [
      _c("div", { staticClass: "itp text-center container" }, [
        _c(
          "h2",
          {
            staticClass: "h4 itp__title text-center",
            class: _vm.schema.settings.sectionHeaderColor
          },
          [_vm._v(_vm._s(_vm.schema.settings.sectionHeader))]
        ),
        _c(
          "div",
          { staticClass: "itp__blocks itp__static" },
          _vm._l(_vm.schema.blocks, function(block) {
            return block.settings.itp_logo
              ? _c(
                  block.settings.itp_url ? "a" : "div",
                  {
                    key: block.id,
                    tag: "component",
                    staticClass: "itp__itp",
                    attrs: {
                      href: block.settings.itp_url,
                      target: block.settings.itp_link_target || "_self"
                    }
                  },
                  [
                    block.settings.itp_logo
                      ? _c("img", {
                          staticClass: "itp__img",
                          attrs: {
                            "aria-role": "presentation",
                            src: _vm.imageSize(
                              block.settings.itp_logo,
                              "400x400"
                            ),
                            srcset:
                              _vm.imageSize(
                                block.settings.itp_logo,
                                "200x200"
                              ) +
                              " 1x, " +
                              _vm.imageSize(
                                block.settings.itp_logo,
                                "400x400"
                              ) +
                              " 2x",
                            alt: block.itp_logo_alt
                          }
                        })
                      : _vm._e()
                  ]
                )
              : _vm._e()
          }),
          1
        ),
        _c(
          "div",
          { staticClass: "itp__slider" },
          [
            _c("div", { staticClass: "itp__pagination" }),
            _c(
              "swiper",
              {
                staticClass: "itp__blocks",
                attrs: { options: _vm.swiperOptions }
              },
              _vm._l(_vm.schema.blocks, function(block) {
                return block.settings.itp_logo
                  ? _c(
                      "swiper-slide",
                      { key: block.id },
                      [
                        block.settings.itp_logo
                          ? _c(
                              block.settings.itp_url ? "a" : "div",
                              {
                                tag: "component",
                                staticClass: "itp__itp",
                                attrs: {
                                  href: block.settings.itp_url,
                                  target:
                                    block.settings.itp_link_target || "_self"
                                }
                              },
                              [
                                block.settings.itp_logo
                                  ? _c("img", {
                                      staticClass: "itp__img",
                                      attrs: {
                                        "aria-role": "presentation",
                                        src: _vm.imageSize(
                                          block.settings.itp_logo,
                                          "400x400"
                                        ),
                                        srcset:
                                          _vm.imageSize(
                                            block.settings.itp_logo,
                                            "200x200"
                                          ) +
                                          " 1x, " +
                                          _vm.imageSize(
                                            block.settings.itp_logo,
                                            "400x400"
                                          ) +
                                          " 2x",
                                        alt: block.itp_logo_alt
                                      }
                                    })
                                  : _vm._e()
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              }),
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }